import NoDataAvailable from "./NoDataAvailable";

export default NoDataAvailable;



// WEBPACK FOOTER //
// ./src/components/common/errorBoundary/noDataAvailable/index.js